<template>
  <div>
    <div class="d-flex justify-content-between align-items-center mb-3">
      <div>
        <h4 class="mb-1">Порядок типов мест</h4>
        <div class="text-muted">Перетащите категории в нужном порядке.</div>
      </div>
      <div class="d-flex">
        <b-button variant="primary" class="mr-2" :disabled="loading || saving" @click="save">
          <b-spinner v-if="saving" small />
          <span v-else>Сохранить</span>
        </b-button>
        <b-button variant="outline-secondary" @click="$router.push({ name: 'PlaceTypes' })">
          Назад
        </b-button>
      </div>
    </div>

    <b-row>
      <b-col lg="6" class="mb-4">
        <order-list
          title="Посетить"
          description="Порядок категорий в разделе «Посетить»."
          :items="travelPlaceTypes"
          :loading="loading"
          :saving="saving"
          :show-edit="false"
          :show-save="false"
          @move="moveTravelPlaceType"
        />
      </b-col>
      <b-col lg="6" class="mb-4">
        <order-list
          title="Отдых"
          description="Порядок категорий в разделе «Отдых»."
          :items="restPlaceTypes"
          :loading="loading"
          :saving="saving"
          :show-edit="false"
          :show-save="false"
          @move="moveRestPlaceType"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import OrderList from '@/components/OrderList.vue';
import { DisplayOrder } from '@/request';

export default {
  name: 'PlaceTypesOrder',
  components: { OrderList },
  data() {
    return {
      placeTypes: [],
      loading: true,
      saving: false,
    };
  },
  computed: {
    travelPlaceTypes() {
      return this.placeTypes.filter(({ type }) => type === 'travel');
    },
    restPlaceTypes() {
      return this.placeTypes.filter(({ type }) => type === 'rest');
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      try {
        this.placeTypes = await DisplayOrder.getPlaceTypesOrder();
      } catch (error) {
        this.showError(error);
      } finally {
        this.loading = false;
      }
    },
    move(list, { movedItemId, dropItemId, placement }) {
      const sourceIndex = list.findIndex(({ id }) => id === movedItemId);
      if (sourceIndex === -1 || movedItemId === dropItemId) return list;

      const reordered = [...list];
      const [item] = reordered.splice(sourceIndex, 1);
      const dropIndex = reordered.findIndex(({ id }) => id === dropItemId);
      reordered.splice(placement === 'after' ? dropIndex + 1 : dropIndex, 0, item);
      return reordered;
    },
    movePlaceType(moveEvent, type) {
      const reorderedType = this.move(
        this.placeTypes.filter((placeType) => placeType.type === type),
        moveEvent,
      );
      let typeIndex = 0;
      this.placeTypes = this.placeTypes.map((placeType) => {
        if (placeType.type !== type) return placeType;
        const reorderedPlaceType = reorderedType[typeIndex];
        typeIndex += 1;
        return reorderedPlaceType;
      });
    },
    moveTravelPlaceType(moveEvent) {
      this.movePlaceType(moveEvent, 'travel');
    },
    moveRestPlaceType(moveEvent) {
      this.movePlaceType(moveEvent, 'rest');
    },
    async save() {
      this.saving = true;
      try {
        this.placeTypes = await DisplayOrder.updatePlaceTypesOrder(
          [
            ...this.travelPlaceTypes,
            ...this.restPlaceTypes,
            ...this.placeTypes.filter(({ type }) => !['travel', 'rest'].includes(type)),
          ].map(({ id }) => id),
        );
        this.$bvToast.toast('Порядок категорий сохранён', { variant: 'success' });
      } catch (error) {
        this.showError(error);
      } finally {
        this.saving = false;
      }
    },
    showError(error) {
      const message = error.response?.data?.message || error.message;
      this.$bvToast.toast(message, { variant: 'danger' });
    },
  },
};
</script>
